import { createFileRoute } from '@tanstack/react-router';
import { TenantsPage } from '@/pages/TenantsPage';

// /tenants is the canonical super-admin route, backed by the same TenantsPage component.
export const Route = createFileRoute('/_auth/tenants')({
  component: TenantsPage,
});
